import { productTypes } from 'types';

const PRODUCT_ACCESS_MAP: Record<string, productTypes> = {
  overnight_product_access: productTypes.OVERNIGHT_DEPOSIT,
  notice_product_access: productTypes.NOTICE_ACCOUNT,
  term_product_access: productTypes.TERM_DEPOSIT,
};

export const matchAccessToProducts = (access?: { [key: string]: boolean }): productTypes[] => {
  let result: productTypes[] = [];

  for (const key in access) {
    if (access[key]) {
      result.push(PRODUCT_ACCESS_MAP[key]);
    }
  }

  return result;
};
